import React__default from 'react';
import { NvAsyncSelect } from '@invitae/ids-react';
import styles from './Select.module.esm.js';

var NoOptionsMessage = 'Search for tests';
var Select = function (_a) {
    var uniqueKey = _a.uniqueKey, loadOptions = _a.loadOptions, onChange = _a.onChange, placeholder = _a.placeholder;
    return (React__default.createElement(NvAsyncSelect, { classes: { root: styles.root }, defaultOptions: true, getOptions: loadOptions, hideLabel: true, key: uniqueKey, label: "select", name: "select-field", noOptionsMessage: NoOptionsMessage, onChange: onChange, placeholder: placeholder }));
};

export { Select as default };
//# sourceMappingURL=index.esm.js.map
